import { useParams, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { LOCAL_STORAGE_KEYS, useLocalStorage } from "./useLocalStorage";
import { DateTime } from "luxon";
import { AffiliatePageParams } from "@portal/app/page/[affiliateSlug]/[industry]/page";

// stores inbound affiliate data in localStorage,
// so that it can later be consumed during signup/lead creation.
export const useAffiliateLocalStorage = () => {
  const searchParams = useSearchParams();
  const params = useParams<AffiliatePageParams>();
  const customer = searchParams?.get("customer");

  const [, setAffiliateSlug] = useLocalStorage<string>(LOCAL_STORAGE_KEYS.AFFILIATE_SLUG);
  const [, setAffiliateFirstEncounteredAt] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.AFFILIATE_FIRST_ENCOUNTERED_AT
  );
  const [, setAffiliateExternalId] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.AFFILIATE_EXTERNAL_ID
  );

  useEffect(() => {
    // when an affiliate page is visited, save affiliate details to localStorage.
    if (params?.affiliateSlug) {
      setAffiliateSlug(params.affiliateSlug as string);
      setAffiliateFirstEncounteredAt(DateTime.now().toISO());
      setAffiliateExternalId(customer ? customer : "");
    }
  }, [
    params?.affiliateSlug,
    customer,
    setAffiliateExternalId,
    setAffiliateFirstEncounteredAt,
    setAffiliateSlug,
  ]);
};
